import { get } from 'lodash';
import * as Yup from 'yup';

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'name', headerName: 'Name', width: 200 },
  { field: 'address', headerName: 'Address', width: 200 },
  { field: 'city', headerName: 'City', width: 200 },
  { field: 'state', headerName: 'Province/State', width: 200 },
  { field: 'postal_code', headerName: 'Postal/ZIP Code', width: 200 },
  { field: 'country', headerName: 'Country', width: 200 },

  { field: 'contact_first_name', headerName: 'First Name', width: 200 },
  { field: 'contact_last_name', headerName: 'Last Name', width: 200 },
  { field: 'contact_title', headerName: 'Title', width: 200 },
  { field: 'contact_email', headerName: 'Email', width: 200 },
  { field: 'contact_phone', headerName: 'Phone Number', width: 200 },
];

export const suggestionPrimaryKey = 'name';

export const suggestionSecondaryKeys = [
  'address',
  'city',
  'state',
  'postal_code',
  'country',
  'contact_first_name',
  'contact_last_name',
  'contact_title',
  'contact_email',
  'contact_phone',
];

export const initialValues = (billTo) => {
  const {
    contact_phone: contactPhone,
    contact_first_name: contactFirstName,
    contact_last_name: contactLastName,
    contact_title: contactTitle,
    contact_email: contactEmail,
  } = billTo || {};

  return {
    name: get(billTo, 'name', ''),
    address: get(billTo, 'address', ''),
    city: get(billTo, 'city', ''),
    state: get(billTo, 'state', ''),
    postalCode: get(billTo, 'postal_code', ''),
    country: get(billTo, 'country', ''),
    contactFirstName: contactFirstName || '',
    contactLastName: contactLastName || '',
    contactTitle: contactTitle || '',
    contactEmail: contactEmail || '',
    contactPhone: contactPhone || '',
  };
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('field is required'),
  address: Yup.string().required('field is required'),
  city: Yup.string().required('field is required'),
  state: Yup.string().required('field is required'),
  postalCode: Yup.string().required('field is required'),
  country: Yup.string().required('field is required'),
  contactFirstName: Yup.string(),
  contactLastName: Yup.string(),
  contactTitle: Yup.string(),
  contactEmail: Yup.string(),
  contactPhone: Yup.string(),
});
